import { isSchedulingActive, type Scheduling } from "~/sdk/contentScheduling"

/** @titleBy question */
interface Question {
    /**
     * @title Pergunta
     */
    question: string

    /**
     * @title Resposta
     * @format html
     */
    answer: string

    /**
     * @title Agendamento
     * @description Deixe este campo vazio para manter sempre visível
     */
    scheduling?: Scheduling
}

export interface Props {
    /**
     * @title Perguntas
     */
    questions: Question[]
}

export default function FAQ({ questions }: Props) {
    if (!questions?.length) return null

    const activeQuestions = questions.filter(({ scheduling }) => isSchedulingActive(scheduling))

    return (
        <ul className='grid gap-3'>
            {activeQuestions.map(({ question, answer }) => (
                <li className='collapse collapse-plus border border-[#d7d7d7] rounded-none'>
                    <input type='checkbox' aria-label='Abrir Pergunta' />

                    <h2 className='collapse-title min-h-max py-4 pl-5 pr-12 text-black font-bold uppercase after:!w-max after:!h-max after:text-2xl after:!top-7 after:-translate-y-1/2 after:!right-5'>
                        {question}
                    </h2>

                    <div
                        className='institutional-hyperlinks collapse-content px-5 text-black [&_p]:mt-3 [&_p]:text-[15px] [&_p]:font-medium'
                        dangerouslySetInnerHTML={{ __html: answer }}
                    />
                </li>
            ))}
        </ul>
    )
}
